export default __webpack_public_path__ + "static/media/100-assurancelife.84f54ef6.svg";